// The tuple is the single source of truth: the union is derived from it, so a role added or
// removed here updates both the compile-time type and every runtime check (@IsIn, SSO default-role
// validation) at once. Do NOT hand-write the union separately — that lets the two drift, compiling
// a role the runtime list rejects.
export const USER_ROLES = ['superAdmin', 'admin', 'billingManager', 'teamMember', 'guest'] as const;

export type UserRole = typeof USER_ROLES[number];
